import { getResearchQuestions, getResearchDisplay, postResearchAnswer } from './../../Api/researchApi'

const state = {
  requesting: {
    questions: false,
    display: false,
    sendAnswer: false
  },

  questions: [],
  display: false,
  selectedAnswer: null
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_questions(state, questions) {
    state.questions = questions
  },

  set_answer(state, answer) {
    state.selectedAnswer = answer
  }

}

const actions = {

  async getQuestions({commit}) {
    commit('request_start', 'questions')

    try {
      const { data } = await getResearchQuestions()

      commit('set_questions', data)

      commit('request_success', 'questions')


      return data
    } catch (error) {
      commit('request_failure', 'questions')

      throw error
    }
  },

  async getDisplay({commit}) {
    commit('request_start', 'display')

    try {
      const { data } = await getResearchDisplay()

      commit('request_success', 'display')


      return data
    } catch (error) {
      commit('request_failure', 'display')

      throw error
    }
  },

  async updateAnswer({commit}, answer) {
    commit('set_answer', answer)
  },

  async sendAnswer({state, commit}){
    commit('request_start', 'sendAnswer')

    try {
      commit('request_success', 'sendAnswer')

      const payload = {
        questionId: state.selectedAnswer.id,
        answerId: state.selectedAnswer.value.id
      }

      const { data } = await postResearchAnswer(payload)

      return data
    } catch (error) {
      commit('request_failure', 'sendAnswer')

      throw error
    }
  }

}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}